import request from '@/utils/request'


export function exportData(data) {
  return request({
    url: 'CheckKneeHurt/exportData',
    method: 'post',
    data
  })
}

export function getPageList(data) {
  return request({
    url: 'CheckKneeHurt/getPageList',
    method: 'post',
    data
  })
}
